export var GameTypeEnum = /*#__PURE__*/ function(GameTypeEnum) {
    GameTypeEnum[GameTypeEnum["Unknown"] = 0] = "Unknown";
    GameTypeEnum[GameTypeEnum["Tutorial"] = 1] = "Tutorial";
    GameTypeEnum[GameTypeEnum["BotGame"] = 2] = "BotGame";
    GameTypeEnum[GameTypeEnum["CreatedRoomGame"] = 3] = "CreatedRoomGame";
    GameTypeEnum[GameTypeEnum["MatchmakingGame"] = 5] = "MatchmakingGame";
    GameTypeEnum[GameTypeEnum["MatchmakingGameRanked"] = 6] = "MatchmakingGameRanked";
    GameTypeEnum[GameTypeEnum["BeginnerMode"] = 7] = "BeginnerMode";
    GameTypeEnum[GameTypeEnum["CreatedTournamentRoom"] = 8] = "CreatedTournamentRoom";
    return GameTypeEnum;
}({});
export var ModeSettingEnum = /*#__PURE__*/ function(ModeSettingEnum) {
    ModeSettingEnum[ModeSettingEnum["Classic4P"] = 0] = "Classic4P";
    ModeSettingEnum[ModeSettingEnum["TutorialClassic4P"] = 1] = "TutorialClassic4P";
    ModeSettingEnum[ModeSettingEnum["Classic56P"] = 2] = "Classic56P";
    ModeSettingEnum[ModeSettingEnum["Classic78P"] = 3] = "Classic78P";
    ModeSettingEnum[ModeSettingEnum["Seafarers4P"] = 4] = "Seafarers4P";
    ModeSettingEnum[ModeSettingEnum["Seafarers56P"] = 5] = "Seafarers56P";
    ModeSettingEnum[ModeSettingEnum["CitiesAndKnights4P"] = 6] = "CitiesAndKnights4P";
    ModeSettingEnum[ModeSettingEnum["CitiesAndKnights56P"] = 7] = "CitiesAndKnights56P";
    ModeSettingEnum[ModeSettingEnum["CitiesAndKnightsSeafarers4P"] = 8] = "CitiesAndKnightsSeafarers4P";
    ModeSettingEnum[ModeSettingEnum["CitiesAndKnightsSeafarers56P"] = 9] = "CitiesAndKnightsSeafarers56P";
    ModeSettingEnum[ModeSettingEnum["ServerStressTestClassic4P"] = 10] = "ServerStressTestClassic4P";
    ModeSettingEnum[ModeSettingEnum["BeginnerModeClassic4P"] = 11] = "BeginnerModeClassic4P";
    ModeSettingEnum[ModeSettingEnum["ColonistRush4P"] = 12] = "ColonistRush4P";
    return ModeSettingEnum;
}({});
export var MapSettingEnum = /*#__PURE__*/ function(MapSettingEnum) {
    MapSettingEnum[MapSettingEnum["Classic4P"] = 0] = "Classic4P";
    MapSettingEnum[MapSettingEnum["TutorialClassic4P"] = 1] = "TutorialClassic4P";
    MapSettingEnum[MapSettingEnum["Classic4PRandom"] = 2] = "Classic4PRandom";
    MapSettingEnum[MapSettingEnum["Classic56P"] = 3] = "Classic56P";
    MapSettingEnum[MapSettingEnum["Classic78P"] = 4] = "Classic78P";
    // SS# = Seafarers Scenario Map# Map_Name Player#,
    MapSettingEnum[MapSettingEnum["SS1HeadingForNewShores3P"] = 5] = "SS1HeadingForNewShores3P";
    MapSettingEnum[MapSettingEnum["SS1HeadingForNewShores4P"] = 6] = "SS1HeadingForNewShores4P";
    MapSettingEnum[MapSettingEnum["SS1HeadingForNewShores56P"] = 7] = "SS1HeadingForNewShores56P";
    MapSettingEnum[MapSettingEnum["TutorialSS1HeadingForNewShores4P"] = 8] = "TutorialSS1HeadingForNewShores4P";
    MapSettingEnum[MapSettingEnum["SS2FourIslands3P"] = 9] = "SS2FourIslands3P";
    MapSettingEnum[MapSettingEnum["SS2FourIslands4P"] = 10] = "SS2FourIslands4P";
    MapSettingEnum[MapSettingEnum["SS2SixIslands56P"] = 11] = "SS2SixIslands56P";
    MapSettingEnum[MapSettingEnum["TutorialSS2FourIslands4P"] = 12] = "TutorialSS2FourIslands4P";
    MapSettingEnum[MapSettingEnum["SS3FogIslands3P"] = 13] = "SS3FogIslands3P";
    MapSettingEnum[MapSettingEnum["SS3FogIslands4P"] = 14] = "SS3FogIslands4P";
    MapSettingEnum[MapSettingEnum["SS3FogIslands56P"] = 15] = "SS3FogIslands56P";
    MapSettingEnum[MapSettingEnum["TutorialSS3FogIsland4P"] = 16] = "TutorialSS3FogIsland4P";
    MapSettingEnum[MapSettingEnum["SS4ThroughTheDesert3P"] = 17] = "SS4ThroughTheDesert3P";
    MapSettingEnum[MapSettingEnum["SS4ThroughTheDesert4P"] = 18] = "SS4ThroughTheDesert4P";
    MapSettingEnum[MapSettingEnum["SS4ThroughTheDesert56P"] = 19] = "SS4ThroughTheDesert56P";
    MapSettingEnum[MapSettingEnum["TutorialSS4ThroughTheDesert4P"] = 20] = "TutorialSS4ThroughTheDesert4P";
    MapSettingEnum[MapSettingEnum["KingOfTheHill"] = 21] = "KingOfTheHill";
    MapSettingEnum[MapSettingEnum["Earth"] = 22] = "Earth";
    MapSettingEnum[MapSettingEnum["EarthSeafarers"] = 23] = "EarthSeafarers";
    MapSettingEnum[MapSettingEnum["USA"] = 24] = "USA";
    MapSettingEnum[MapSettingEnum["UK"] = 25] = "UK";
    MapSettingEnum[MapSettingEnum["UKSeafarers"] = 26] = "UKSeafarers";
    MapSettingEnum[MapSettingEnum["Diamond"] = 27] = "Diamond";
    MapSettingEnum[MapSettingEnum["Gear"] = 28] = "Gear";
    MapSettingEnum[MapSettingEnum["Lakes"] = 29] = "Lakes";
    MapSettingEnum[MapSettingEnum["Pond"] = 30] = "Pond";
    MapSettingEnum[MapSettingEnum["Twirl"] = 31] = "Twirl";
    MapSettingEnum[MapSettingEnum["ShuffleBoard"] = 32] = "ShuffleBoard";
    MapSettingEnum[MapSettingEnum["BlackForest"] = 33] = "BlackForest";
    MapSettingEnum[MapSettingEnum["Volcano"] = 34] = "Volcano";
    MapSettingEnum[MapSettingEnum["Circle"] = 35] = "Circle";
    MapSettingEnum[MapSettingEnum["Kite"] = 36] = "Kite";
    MapSettingEnum[MapSettingEnum["Romania"] = 37] = "Romania";
    MapSettingEnum[MapSettingEnum["MiniBase"] = 38] = "MiniBase";
    MapSettingEnum[MapSettingEnum["Monopoly"] = 39] = "Monopoly";
    MapSettingEnum[MapSettingEnum["MountainOfRiches"] = 40] = "MountainOfRiches";
    MapSettingEnum[MapSettingEnum["Doggo"] = 41] = "Doggo";
    MapSettingEnum[MapSettingEnum["Duel"] = 42] = "Duel";
    MapSettingEnum[MapSettingEnum["TradeIslands"] = 43] = "TradeIslands";
    MapSettingEnum[MapSettingEnum["TradeIslandsSeafarers"] = 44] = "TradeIslandsSeafarers";
    MapSettingEnum[MapSettingEnum["Vietnam"] = 45] = "Vietnam";
    MapSettingEnum[MapSettingEnum["TurningTidesSeafarers"] = 46] = "TurningTidesSeafarers";
    MapSettingEnum[MapSettingEnum["TurningTidesClassic"] = 47] = "TurningTidesClassic";
    MapSettingEnum[MapSettingEnum["TwoIsles"] = 48] = "TwoIsles";
    MapSettingEnum[MapSettingEnum["JellyFish"] = 49] = "JellyFish";
    MapSettingEnum[MapSettingEnum["GoldRush"] = 50] = "GoldRush";
    MapSettingEnum[MapSettingEnum["Istanbul"] = 51] = "Istanbul";
    MapSettingEnum[MapSettingEnum["IstanbulSeafarers"] = 52] = "IstanbulSeafarers";
    MapSettingEnum[MapSettingEnum["Europe"] = 53] = "Europe";
    MapSettingEnum[MapSettingEnum["EuropeSeafarers"] = 54] = "EuropeSeafarers";
    MapSettingEnum[MapSettingEnum["Stripes"] = 55] = "Stripes";
    MapSettingEnum[MapSettingEnum["MonopolyIslands"] = 56] = "MonopolyIslands";
    MapSettingEnum[MapSettingEnum["MonopolyIslandsSeafarers"] = 57] = "MonopolyIslandsSeafarers";
    MapSettingEnum[MapSettingEnum["CampaignLevel1"] = 58] = "CampaignLevel1";
    MapSettingEnum[MapSettingEnum["CampaignLevel2"] = 59] = "CampaignLevel2";
    MapSettingEnum[MapSettingEnum["CampaignRoadRace"] = 60] = "CampaignRoadRace";
    MapSettingEnum[MapSettingEnum["CampaignRoadRace2"] = 61] = "CampaignRoadRace2";
    return MapSettingEnum;
}({});
export const ARCHIVED_MAP_SETTING_ENUMS = [
    60,
    61
];
export function getDefaultMapForGameMode(mode) {
    switch(mode){
        case 0:
            return 0;
        case 1:
            return 1;
        case 11:
            return 58;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 6;
        case 5:
            return 7;
        case 6:
            return 0;
        case 7:
            return 3;
        case 8:
            return 6;
        case 9:
            return 7;
        case 10:
            return 1;
        default:
            return 0;
    }
}
export var GameSpeedSettings = /*#__PURE__*/ function(GameSpeedSettings) {
    GameSpeedSettings[GameSpeedSettings["Base30s"] = 0] = "Base30s";
    GameSpeedSettings[GameSpeedSettings["Base60s"] = 1] = "Base60s";
    GameSpeedSettings[GameSpeedSettings["Base120s"] = 2] = "Base120s";
    GameSpeedSettings[GameSpeedSettings["Base240s"] = 3] = "Base240s";
    GameSpeedSettings[GameSpeedSettings["Base12000s"] = 4] = "Base12000s";
    GameSpeedSettings[GameSpeedSettings["Rush5s"] = 5] = "Rush5s";
    GameSpeedSettings[GameSpeedSettings["Rush8s"] = 6] = "Rush8s";
    GameSpeedSettings[GameSpeedSettings["Rush10s"] = 7] = "Rush10s";
    GameSpeedSettings[GameSpeedSettings["Rush15s"] = 8] = "Rush15s";
    GameSpeedSettings[GameSpeedSettings["Rush20s"] = 9] = "Rush20s";
    GameSpeedSettings[GameSpeedSettings["Base15s"] = 10] = "Base15s";
    return GameSpeedSettings;
}({});
export var ELOTypeEnum = /*#__PURE__*/ function(ELOTypeEnum) {
    ELOTypeEnum[ELOTypeEnum["Inactive"] = 0] = "Inactive";
    ELOTypeEnum[ELOTypeEnum["HiddenUnranked1v1"] = 1] = "HiddenUnranked1v1";
    ELOTypeEnum[ELOTypeEnum["HiddenUnranked4PClassic"] = 2] = "HiddenUnranked4PClassic";
    ELOTypeEnum[ELOTypeEnum["VisibleRanked1v1"] = 3] = "VisibleRanked1v1";
    ELOTypeEnum[ELOTypeEnum["VisibleRanked4PClassic"] = 4] = "VisibleRanked4PClassic";
    ELOTypeEnum[ELOTypeEnum["VisibleRankedCitiesAndKnights4P"] = 5] = "VisibleRankedCitiesAndKnights4P";
    ELOTypeEnum[ELOTypeEnum["HiddenUnrankedShuffle"] = 6] = "HiddenUnrankedShuffle";
    ELOTypeEnum[ELOTypeEnum["VisibleRanked4PRush"] = 7] = "VisibleRanked4PRush";
    return ELOTypeEnum;
}({});
export var ExtensionSettingEnum = /*#__PURE__*/ function(ExtensionSettingEnum) {
    ExtensionSettingEnum[ExtensionSettingEnum["Players4"] = 0] = "Players4";
    ExtensionSettingEnum[ExtensionSettingEnum["Players56"] = 1] = "Players56";
    ExtensionSettingEnum[ExtensionSettingEnum["Players78"] = 2] = "Players78";
    return ExtensionSettingEnum;
}({});
export var ScenarioSettingEnum = /*#__PURE__*/ function(ScenarioSettingEnum) {
    ScenarioSettingEnum[ScenarioSettingEnum["None"] = 0] = "None";
    ScenarioSettingEnum[ScenarioSettingEnum["SS1HeadingForNewShores"] = 1] = "SS1HeadingForNewShores";
    ScenarioSettingEnum[ScenarioSettingEnum["SS2TheFourIslands"] = 2] = "SS2TheFourIslands";
    ScenarioSettingEnum[ScenarioSettingEnum["SS3TheFogIslands"] = 3] = "SS3TheFogIslands";
    ScenarioSettingEnum[ScenarioSettingEnum["SS4ThroughTheDesert"] = 4] = "SS4ThroughTheDesert";
    return ScenarioSettingEnum;
}({});
export var DiceSettingEnum = /*#__PURE__*/ function(DiceSettingEnum) {
    DiceSettingEnum[DiceSettingEnum["Random"] = 0] = "Random";
    DiceSettingEnum[DiceSettingEnum["Balanced"] = 1] = "Balanced";
    DiceSettingEnum[DiceSettingEnum["StressTestSequence"] = 2] = "StressTestSequence";
    DiceSettingEnum[DiceSettingEnum["PredefinedDiceSequenceDeleted"] = 3] = "PredefinedDiceSequenceDeleted";
    return DiceSettingEnum;
}({});
export var BotSpeedSettings = /*#__PURE__*/ function(BotSpeedSettings) {
    BotSpeedSettings[BotSpeedSettings["Fast"] = 0] = "Fast";
    BotSpeedSettings[BotSpeedSettings["Normal"] = 1] = "Normal";
    BotSpeedSettings[BotSpeedSettings["Slow"] = 2] = "Slow";
    return BotSpeedSettings;
}({});
